import { render, staticRenderFns } from "./ServiceTicketMaterialsComponent.vue?vue&type=template&id=412e48e5&scoped=true"
import script from "./ServiceTicketMaterialsComponent.vue?vue&type=script&lang=js"
export * from "./ServiceTicketMaterialsComponent.vue?vue&type=script&lang=js"
import style0 from "./ServiceTicketMaterialsComponent.vue?vue&type=style&index=0&id=412e48e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412e48e5",
  null
  
)

export default component.exports